/* eslint-disable no-unreachable */
import axios from 'axios'
// import PromiseFinally from 'promise.prototype.finally'
import { Message } from 'element-ui'
import debounce from 'lodash/debounce'

// PromiseFinally.shim()
axios.defaults.timeout = 5000;
axios.defaults.withCredentials = true;
// http request 拦截器
axios.interceptors.request.use(
  config => {
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  debounce(error => {
    if (error.response) {
      let err = null
      let errorMsg
      switch (error.response.status) {
        case 401:
          if (error.response && error.response.config && error.response.config.unCheckLogin) {
            break
          }
          // window.location.href = 'https://passport.csdn.net/account/login?from=' + encodeURIComponent(window.location.href)
          break
        case 403:
          errorMsg = '您目前没有权限进行当前操作'
          err = new Error(errorMsg)
          break
        case 422:
          errorMsg = '您的信息不完整，请补全用户信息！'
          err = new Error(errorMsg)
          break
        case 400:
          return Promise.reject(error.response)
        default:
          errorMsg = (error.response.status + ' ' + error.response.statusText) || '系统异常,请稍后再试'
          err = new Error(errorMsg)
          break
      }
      return Promise.reject(err)
    } else {
      Message({
        type: 'error',
        message: '服务超时,请刷新页面重试',
        showClose: true,
        center: true,
        customClass: 'common_tip',
        duration: 3000
      })
    }
  }, 1000)

)

export default axios
